<template>
  <div>
    <Header></Header>
    <main id="content" role="main">
      <div class="position-relative">
        <div class="
            container
            space-top-2 space-top-lg-1 space-bottom-md-2
            position-relative
            z-index-2
          ">
          <div class="w-md-80 w-lg-60 text-center mx-md-auto mb-9">
            <div class="mb-5">
              <h1>欢迎加入我们</h1>
              <p>
                我们希望与充满干劲，才华横溢的年轻人共同合作，创造充满希望的产品。
              </p>
            </div>
            <!-- <a
              class="btn btn-primary btn-wide transition-3d-hover"
              href="#openRolesSection"
              >投递简历</a
            > -->
          </div>

          <!-- Gallery Section -->
          <div class="clearfix mx-3 mx-md-11">
            <img class="img-fluid rounded" src="@/assets/img/1920x800/img2.jpg" alt="Image Description" />
          </div>
          <!-- End Gallery Section -->

          <!-- Jobs Section -->
          <div id="openRolesSection" class="container space-2 space-lg-3">
            <!-- Title -->
            <div class="w-md-80 w-lg-50 text-center mx-md-auto mb-5 mb-md-9">
              <span class="d-block small font-weight-bold text-cap mb-2">空缺职位</span>
              <h2>当前空缺职位</h2>
            </div>
            <!-- End Title -->

            <!-- Filters -->
            <div class="border-bottom pb-5 mb-9">
              <div class="row align-items-center">
                <div class="col-sm text-sm-right">
                  <span class="text-dark font-weight-bold">{{jobsLength}}</span>
                  个岗位正在招聘
                </div>
              </div>
            </div>
            <!-- End Filters -->
            <div v-for="(item,index) in zhaopinList" :key="index">
              <!-- Title -->
              <div class="row justify-content-lg-between align-items-lg-center mt-7 mb-3">
                <div class="col-sm-auto">
                  <h3 class="h4">{{item.name}}</h3>
                </div>
                <div class="col-sm text-sm-right">
                  <small>{{item.jobs.length}} 岗位</small>
                </div>
              </div>
              <!-- End Title -->

              <!-- Card -->
              <div class="card card-frame py-3 px-4 mb-2" v-for="(itemjob,indexJob) in item.jobs" :key="indexJob"  @click="goDetail(itemjob)">
                <div class="row align-items-sm-center">
                  <span class="col-sm-6 text-dark"> {{itemjob.recruitJob?itemjob.recruitJob.name:'--'}} </span>
                  <span class="col-6 col-sm-3 text-body">{{getDictName(getDictDetail('address'),itemjob.address)}} </span>
                  <span class="col-6 col-sm-3 text-right" :class="{'colorBlue':itemjob.state}">
                    {{itemjob.state?'招录详情':'暂无计划'}} <i class="fas fa-angle-right fa-sm ml-1"></i>
                  </span>
                </div>
              </div>
              <!-- End Card -->
            </div>

            <div class="text-center mt-5">
              <p>
                找不到合适的岗位?
                <router-link class="font-weight-bold text-nowrap" to="/contact">联系我们 <i class="fas fa-angle-right fa-sm ml-1"></i></router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import '@/assets/vendor/jquery/dist/jquery.min.js' //1
import '@/assets/vendor/jquery-migrate/dist/jquery-migrate.min.js' //2
import '@/assets/vendor/hs-show-animation/dist/hs-show-animation.min.js' //8
import '@/assets/vendor/jquery-validation/dist/jquery.validate.min.js' //9
import '@/assets/vendor/hs-video-player/dist/hs-video-player.min.js'
import '@/assets/js/hs.validation.js' //11

import '@/assets/vendor/font-awesome/css/all.min.css' //12
import '@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.css' //13
import '@/assets/css/theme.css' //14
import '@/assets/vendor/hs-header/dist/hs-header.min.js' //4
import '@/assets/vendor/hs-go-to/dist/hs-go-to.min.js' //5
import '@/assets/vendor/hs-unfold/dist/hs-unfold.min.js' //6
import '@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.js' //7
import AOS from 'aos'
import 'bootstrap/dist/js/bootstrap.bundle.min.js' //3

import '@/assets/js/hs.core.js' //10
import Header from '@/components/header'
import Footer from '@/components/footer'
import { getZhaoPinList } from '@/request/index'
import dictMixins from '@/mixins/dictMixins'
export default {
  mixins: [dictMixins],
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      zhaopinList: [],
      jobsLength:0,
    }
  },
  mounted() {
    $(document).ready(function () {
      // var header = new HSHeader($("#header")).init();

      // initialization of mega menu
      var megaMenu = new HSMegaMenu($('.js-mega-menu'), {
        desktop: {
          position: 'left',
        },
      }).init()

      // initialization of unfold
      var unfold = new HSUnfold('.js-hs-unfold-invoker').init()

      $('.js-animation-link').each(function () {
        var showAnimation = new HSShowAnimation($(this)).init()
      })

      // initialization of form validation
      $('.js-validate').each(function () {
        $.HSCore.components.HSValidation.init($(this), {
          rules: {
            confirmPassword: {
              equalTo: '#signupPassword',
            },
          },
        })
      })

      // initialization of video player
      $('.js-inline-video-player').each(function () {
        var videoPlayer = new HSVideoPlayer($(this)).init()
      })

      // initialization of go to
      $('.js-go-to').each(function () {
        var goTo = new HSGoTo($(this)).init()
      })
    })
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      getZhaoPinList({ page: 0, size: 999 }).then((res) => {
        this.jobsLength = res.data.content.filter(item=>item.state).length
        this.zhaopinList = []
        let departments = this.getDictDetail('recruit_dept')
        departments.forEach(item => {
            item.jobs=[]
          res.data.content.forEach(jobitem => {
            if (jobitem.dept == item.value) {
              item.jobs.push(jobitem)
            }
          })
          this.zhaopinList.push ({ name: item.label, jobs: item.jobs? item.jobs:[] }) 
        })
      })
    },
    goDetail(val){
        if(val.state){
            this.$router.push({ path: '/recruitdetail', query: { id: val.id} })
        }
    }
  },
}
</script>

<style scoped>
.colorBlue{
    color: #007bff;
    cursor: pointer;
}
.mb-5 h1 {
  margin-bottom: 0.5rem;
  font-size: 2.5rem;
  font-weight: 600;
  line-height: 1.4;
}
.mb-5 p {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
}
.btn {
  display: inline-block;
  font-weight: 600;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  border: 0.0625rem solid transparent;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  line-height: 1.6;
  border-radius: 0.3125rem;
}
.mb-5 span {
  line-height: 1.6;
  color: #677788;
}
.mb-5 h2 {
  margin-bottom: 0.5rem;
  font-size: 1.875rem;
  font-weight: 600;
  line-height: 1.4;
}
.text-sm-right small,
.text-sm-right {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
}
a {
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/view/recruit.vue